import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { AccountResource } from './Account';
import { EmailTypeResource } from './EmailType';

/**
 * Relationship classes
 */
export class AccountEmailPreferenceAttributes {
  enabled: boolean = null;
}

export class AccountEmailPreferenceBelongsTo {
  account: () => AccountResource = () => new AccountResource();
  emailType: () => EmailTypeResource = () => new EmailTypeResource();
}

export class AccountEmailPreferenceHasOne {}

export class AccountEmailPreferenceHasMany {}

/**
 * Utility interfaces
 */
export interface AccountEmailPreferenceMethods {}

export interface AccountEmailPreferenceInterface
  extends AccountEmailPreferenceAttributes,
    AccountEmailPreferenceBelongsTo,
    AccountEmailPreferenceHasOne,
    AccountEmailPreferenceHasMany,
    AccountEmailPreferenceType {}

type AccountEmailPreferenceType = GConstructor<AccountEmailPreferenceInterface>;

export interface AccountEmailPreferenceResource
  extends Base<AccountEmailPreferenceAttributes>,
    AccountEmailPreferenceInterface,
    AccountEmailPreferenceMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<AccountEmailPreferenceAttributes>({
    queryName: 'account_email_preferences',
    className: 'AccountEmailPreference',
    AttributesClass: AccountEmailPreferenceAttributes,
    BelongsToClasses: [
      {
        Klass: AccountEmailPreferenceBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: AccountEmailPreferenceHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: AccountEmailPreferenceHasMany,
      },
    ],
  });

export const AccountEmailPreferenceResourceClass = <TBase extends AccountEmailPreferenceType>(
  BaseConstructor: TBase,
) => class extends BaseConstructor implements AccountEmailPreferenceMethods {};

export class AccountEmailPreferenceResource extends ClassExtender<AccountEmailPreferenceInterface>(
  BaseClass,
  AccountEmailPreferenceResourceClass,
) {}

/**
 * Resource instance
 */
export const AccountEmailPreference = APILibrary.createResource<AccountEmailPreferenceResource>(
  AccountEmailPreferenceResource,
);
